import React from "react";


function ToCartButtonComponent({ itemCount, handleClick }) {

    return (
        <div style={{padding: '10px'}}>
            <button type="button" className="btn  position-relative rounded-circle" style={{ width: '50px', height: '50px', backgroundColor: '#9CCA4D' }} onClick={handleClick}>
            <i className="bi bi-cart" style={{ fontSize: '24px' }}></i>
            {itemCount > 0 && (
                <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                    {itemCount}
                    <span className="visually-hidden">Quantidade carrinho</span>
                </span>
            )}
        </button>
        </div>
    );
}

export default ToCartButtonComponent;
